import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  baseRelatedPspBranchActions,
  baseRelatedPspBranchesSelectors,
  BaseCoreState,
  BaseRelatedPspPayloadInterface,
} from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerServiceProviderGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseRelatedPspBranchActions.loadRelatedPspBranchList({
        payload: route.queryParams as BaseRelatedPspPayloadInterface,
      })
    );

    return this.store.select(baseRelatedPspBranchesSelectors.getRelatedPspBranchList).pipe(
      filter((result) => result.ok !== undefined),
      map((result) => !!result.ok)
    );
  }
}
